import { render, staticRenderFns } from "./StepsThird.vue?vue&type=template&id=3aa598ae&scoped=true"
import script from "./StepsThird.vue?vue&type=script&lang=js"
export * from "./StepsThird.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa598ae",
  null
  
)

export default component.exports